import React from 'react';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const Imprimir = () => {
    const navigate = useNavigate();
    const anio = new Date().getFullYear();
    const mes = new Date().getMonth() + 1;
    const dia = new Date().getDate();
    const fecha = dia + '/' + mes + '/' + anio;

    useEffect(() => {
        getUser();
        getEducacion();
    }, []);

    const userString = localStorage.getItem('logged_user');
    const user = userString ? JSON.parse(userString) : null;
    const [base64, setBase64] = useState('');

    const json = {
        nombre: '',
        ingreso: '',
        actualizacion: '',
        genero: '',
        hijos: '',
        estadocivil: '',
        tiposangre: '',
        estatura: '',
        nacionalidad: '',
        lugarnacimiento: '',
        direccion: '',
        telefonos: '',
        telefonotrabajo: '',
        licencia: '',
        discapacidad: '',
        parentescofamiliar: '',
        nombrefamiliar: '',
        generofamiliar: '',
        nacimientofamiliar: '',
        telefonosfamiliar: '',
        ocupacionfamiliar: '',
        trabajofamiliar: '',
        telefonotrabajofamiliar: '',
        titulobachiller: '',
        especialidadbachiller: '',
        finalizacionbachiller: '',
        institucionbachiller: '',
        lugarbachiller: '',
        aniosbachiller: '',
        titulopre: '',
        especialidadpre: '',
        finalizacionpre: '',
        institucionpre: '',
        lugarpre: '',
        aniospre: '',
        titulotecnico: '',
        especialidadtecnico: '',
        finalizaciontecnico: '',
        instituciontecnico: '',
        lugartecnico: '',
        aniostecnico: '',
        titulotecno: '',
        especialidadtecno: '',
        finalizaciontecno: '',
        instituciontecno: '',
        lugartecno: '',
        aniostecno: '',
        titulopostgrado: '',
        especialidadpostgrado: '',
        finalizacionpostgrado: '',
        institucionpostgrado: '',
        lugarpostgrado: '',
        aniospostgrado: '',
        titulodoctorado: '',
        especialidaddoctorado: '',
        finalizaciondoctorado: '',
        instituciondoctorado: '',
        lugardoctorado: '',
        aniosdoctorado: '',
        idiomas: [
            {
                idioma: '',
                comprende: '',
                habla: '',
                lee: '',
                escribe: '',
                traduce: ''
            }
        ],
        cursos: [
            {
                curso: '',
                institucion: '',
                horas: '',
                pais: '',
                ciudad: '',
                anio: ''
            }
        ],
        experienciatrabaja: '',
        experienciaingreso: '',
        experienciaempresa: '',
        experienciacargo: '',
        experienciajefe: '',
        experienciacargojefe: '',
        experienciacontacto: '',
        experienciaciudad: '',
        trayectoria: [
            {
                cargo: '',
                empresa: '',
                ingreso: '',
                salida: '',
            }
        ],
        condicionremuneracion: '',
        condicioneventual: '',
        condicionviajar: '',
        condicioncambio: '',
        condicionturnos: '',
        condiciondisponibilidad: '',
        condicionfechaingresar: '',
        condiciontrabajoeeq: '',
        evaluacion: [
            {
                periodoevaluacion: '',
                institucionevaluacion: '',
                evaluacionobtenida: '',
            }
        ],
        eventos: [
            {
                institucionexposicion: '',
                temaexpuesto: '',
                fechaexposicion: '',
                duracionexposicion: '',
                documentoexposicion: '',
            }
        ],
        premios: [
            {
                institucionpremio: '',
                temapremio: '',
                fechapremio: '',
                documentopremio: '',
            }
        ],
        servicios: [
            {
                institucionservicio: '',
                motivoservicio: '',
                fechaservicio: '',
            }
        ],
        referencias: [
            {
                nombresreferencia: '',
                lugarreferencia: '',
                cargoreferencia: '',
                telefonoreferencia: '',
                telefonoalterreferencia: '',
            }
        ],
    };

    const idiomas = (idioma: number) => {
        switch (idioma) {
            case 1:
                return 'ALEMAN';
            case 2:
                return 'ARABE';
            case 3:
                return 'FINLANDES';
            case 4:
                return 'FRANCES';
            case 5:
                return 'INGLES';
            case 6:
                return 'MANDARIN';
            case 7:
                return 'PORTUGUES';
            case 8:
                return 'QUECHUA';
            case 9:
                return 'QUICHUA';
            case 10:
                return 'RUSO';
            case 11:
                return 'SUECO';
            default:
                return '';
        }
    };

    const comprende = (comprende: string) => {
        switch (comprende) {
            case 'NA':
                return 'NADA';
            case 'RE':
                return 'REGULAR';
            case 'BI':
                return 'BIEN';
            case 'MB':
                return 'MUY BIEN';
            case 'EX':
                return 'EXCELENTE';
            default:
                return '';
        }
    };


    const estadoCivil = (estado: string) => {
        switch (estado) {
            case 'S':
                return 'SOLTERO';
            case 'C':
                return 'CASADO';
            case 'D':
                return 'DIVORCIADO';
            case 'V':
                return 'VIUDO';
            case 'U':
                return 'UNION LIBRE';
            default:
                return '';
        }
    };

    const getEducacion = async () => {
        const datosEducacion = await fetch(`${process.env.REACT_APP_API_URL}datos_educacion/${user.PER_ASPI_ID}`);
        const dataEducacion = await datosEducacion.json();

        const obtenerEspecialidad = async (titulo: string, especialidad: string) => {
            const response = await fetch(`${process.env.REACT_APP_API_URL}titulo/${titulo}/${especialidad}`);
            const data = await response.json();
            return data.data[0][0]?.DESCRIPCION;
        };

        const obtenerTitulo = async (titulo: string) => {
            const response = await fetch(`${process.env.REACT_APP_API_URL}titulo/${titulo}`);
            const data = await response.json();
            return data.data[0][0].DESCRIPCION;
        };

        await Promise.all(dataEducacion.data.map(async (item: any) => {
            if (item.EDU_ASP_TIPO_INSTRUCCION == 'SECUNDARIA') {
                const titulo = await obtenerTitulo(item.TITULO);
                const especialidad = await obtenerEspecialidad(item.TITULO, item.ESPECIALIDAD);
                json.titulobachiller = titulo || '';
                json.especialidadbachiller = especialidad || '';
                json.finalizacionbachiller = item.EDU_ASP_FECHA_HASTA || '';
                json.institucionbachiller = item.EDU_ASP_INSTITUCION || '';
                json.lugarbachiller = item.EDU_ASP_LUGAR || '';
                json.aniosbachiller = item.EDU_ASP_ANIOS || '';
            }
            if (item.EDU_ASP_TIPO_INSTRUCCION == 'TECNICO') {
                const titulo = await obtenerTitulo(item.TITULO);
                const especialidad = await obtenerEspecialidad(item.TITULO, item.ESPECIALIDAD);
                json.titulotecnico = titulo || '';
                json.especialidadtecnico = especialidad || '';
                json.finalizaciontecnico = item.EDU_ASP_FECHA_HASTA || '';
                json.instituciontecnico = item.EDU_ASP_INSTITUCION || '';
                json.lugartecnico = item.EDU_ASP_LUGAR || '';
                json.aniostecnico = item.EDU_ASP_ANIOS || '';
            }
            if (item.EDU_ASP_TIPO_INSTRUCCION == 'TECNOLOGO') {
                const titulo = await obtenerTitulo(item.TITULO);
                const especialidad = await obtenerEspecialidad(item.TITULO, item.ESPECIALIDAD);
                json.titulotecno = titulo || '';
                json.especialidadtecno = especialidad || '';
                json.finalizaciontecno = item.EDU_ASP_FECHA_HASTA || '';
                json.instituciontecno = item.EDU_ASP_INSTITUCION || '';
                json.lugartecno = item.EDU_ASP_LUGAR || '';
                json.aniostecno = item.EDU_ASP_ANIOS || '';
            }
            if (item.EDU_ASP_TIPO_INSTRUCCION == 'UNIVERSITARIA') {
                const titulo = await obtenerTitulo(item.TITULO);
                const especialidad = await obtenerEspecialidad(item.TITULO, item.ESPECIALIDAD);
                json.titulopre = titulo || '';
                json.especialidadpre = especialidad || '';
                json.finalizacionpre = item.EDU_ASP_FECHA_HASTA || '';
                json.institucionpre = item.EDU_ASP_INSTITUCION || '';
                json.lugarpre = item.EDU_ASP_LUGAR || '';
                json.aniospre = item.EDU_ASP_ANIOS || '';
            }
            if (item.EDU_ASP_TIPO_INSTRUCCION == 'POSTGRADO') {
                const titulo = await obtenerTitulo(item.TITULO);
                const especialidad = await obtenerEspecialidad(item.TITULO, item.ESPECIALIDAD);
                json.titulopostgrado = titulo || '';
                json.especialidadpostgrado = especialidad || '';
                json.finalizacionpostgrado = item.EDU_ASP_FECHA_HASTA || '';
                json.institucionpostgrado = item.EDU_ASP_INSTITUCION || '';
                json.lugarpostgrado = item.EDU_ASP_LUGAR || '';
                json.aniospostgrado = item.EDU_ASP_ANIOS || '';
            }
            if (item.EDU_ASP_TIPO_INSTRUCCION == 'DOCTORADO') {
                const titulo = await obtenerTitulo(item.TITULO);
                const especialidad = await obtenerEspecialidad(item.TITULO, item.ESPECIALIDAD);
                json.titulodoctorado = titulo || '';
                json.especialidaddoctorado = especialidad || '';
                json.finalizaciondoctorado = item.EDU_ASP_FECHA_HASTA || '';
                json.instituciondoctorado = item.EDU_ASP_INSTITUCION || '';
                json.lugardoctorado = item.EDU_ASP_LUGAR || '';
                json.aniosdoctorado = item.EDU_ASP_ANIOS || '';
            }
        }));
    };

    const removeToken = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('logged_user');
        navigate('/');
    }

    setTimeout(() => {
        removeToken();
    }, 60 * 60 * 1000);

    const getUser = async () => {
        const responseNacimiento = await fetch(`${process.env.REACT_APP_API_URL}datos_direccion_pdf/${user.PER_ASPI_ID}`);
        const dataNacimiento = await responseNacimiento.json();
        const responseDireccion = await fetch(`${process.env.REACT_APP_API_URL}datos_direccion_domicilio_pdf/${user.PER_ASPI_ID}`);
        const dataDireccion = await responseDireccion.json();
        const response = await fetch(`${process.env.REACT_APP_API_URL}user/${user.PER_ASPI_ID}`);
        const data = await response.json();
        const responsePersonales = await fetch(`${process.env.REACT_APP_API_URL}datos_personales/${user.PER_ASPI_ID}`);
        const dataPersonales = await responsePersonales.json();
        const responseFamiliares = await fetch(`${process.env.REACT_APP_API_URL}datos_familiares/${user.PER_ASPI_ID}`);
        const dataFamiliares = await responseFamiliares.json();
        const datos_idiomas = await fetch(`${process.env.REACT_APP_API_URL}datos_idiomas/${user.PER_ASPI_ID}`);
        const dataIdiomas = await datos_idiomas.json();
        const trayectoria_laboral = await fetch(`${process.env.REACT_APP_API_URL}trayectoria_laboral/${user.PER_ASPI_ID}`);
        const dataTrayectoria = await trayectoria_laboral.json();
        const detalle_experiencia = await fetch(`${process.env.REACT_APP_API_URL}detalle_experiencia/${user.PER_ASPI_ID}`);
        const dataDetalle = await detalle_experiencia.json();
        const condicion_oferta = await fetch(`${process.env.REACT_APP_API_URL}condicion_oferta/${user.PER_ASPI_ID}`);
        const dataCondicion = await condicion_oferta.json();
        const capacitaciones = await fetch(`${process.env.REACT_APP_API_URL}capacitacion/${user.PER_ASPI_ID}`);
        const dataCapacitaciones = await capacitaciones.json();
        const responseEvaluacion = await fetch(`${process.env.REACT_APP_API_URL}evaluacion/` + user.PER_ASPI_ID);
        const dataEvaluacion = await responseEvaluacion.json();
        const responseEventos = await fetch(`${process.env.REACT_APP_API_URL}eventos/` + user.PER_ASPI_ID);
        const dataEventos = await responseEventos.json();
        const responsePremios = await fetch(`${process.env.REACT_APP_API_URL}premios/` + user.PER_ASPI_ID);
        const dataPremios = await responsePremios.json();
        const responseServicios = await fetch(`${process.env.REACT_APP_API_URL}servicios/` + user.PER_ASPI_ID);
        const dataServicios = await responseServicios.json();
        const responseReferencias = await fetch(`${process.env.REACT_APP_API_URL}referencias/` + user.PER_ASPI_ID);
        const dataReferencias = await responseReferencias.json();
        json.nombre = data.data.PER_ASPI_NOMBRES + ' ' + data.data.PER_ASPI_APELLIDO_PATERNO + ' ' + data.data.PER_ASPI_APELLIDO_MATERNO;
        json.ingreso = data.data.PER_ASPI_FECHA_REGISTRO?.substring(0, 10);
        json.actualizacion = fecha;

        if (dataPersonales.data.length > 0) {
            json.genero = dataPersonales.data[0].DAT_ASP_GENERO == 'M' ? 'MASCULINO' : 'FEMENINO' || '';
            json.hijos = dataPersonales.data[0].DAT_ASP_HIJOS || 0;
            json.estadocivil = estadoCivil(dataPersonales.data[0].DAT_ASP_ESTADO_CIVIL || '');
            json.tiposangre = dataPersonales.data[0].DAT_ASP_TIPO_SANGRE || '';
            json.estatura = dataPersonales.data[0].DAT_ASP_ESTATURA + ' [m]' || '';
            json.nacionalidad = dataNacimiento.data[0].NAC_NOMBRE;
            json.lugarnacimiento = dataNacimiento.data[0].PROVINCIA + ' / ' + dataNacimiento.data[0].CANTON + ' / ' + dataNacimiento.data[0].PARROQUIA;
            json.direccion = dataDireccion.data[0].PROVINCIA + ' / ' + dataDireccion.data[0].CANTON + ' / ' + dataDireccion.data[0].PARROQUIA + ' / ' + dataDireccion.data[0].SECTOR + ' / ' + dataDireccion.data[0].CALLE_P + ' / ' + dataDireccion.data[0].CALLE_S + ' / ' + dataDireccion.data[0].NUMERO;
            json.telefonos = dataPersonales.data[0].DAT_ASP_CELULAR + ' / ' + dataPersonales.data[0].DAT_ASP_TELEFONO_DOMICILIO || '';
            json.telefonotrabajo = dataPersonales.data[0].DAT_ASP_TELEFONO_TRABAJO || '';
            json.licencia = dataPersonales.data[0].DAT_ASP_LICENCIA || '' + 'TIPO DE LICENCIA: ' + dataPersonales.data[0].DAT_ASP_TIPO_LICENCIA || '' + 'CADUCA: ' + dataPersonales.data[0].DAT_ASP_FECHA_CADUCIDAD || '';
            json.discapacidad = dataPersonales.data[0].DAT_ASP_DISCAPACIDAD || '';
        }

        if (dataFamiliares.data.length > 0) {
            json.parentescofamiliar = dataFamiliares.data[0].FAM_ASP_TIPO_FAMILIAR || '';
            json.nombrefamiliar = dataFamiliares.data[0].FAM_ASP_NOMBRES || '' + ' ' + dataFamiliares.data[0].FAM_ASP_APELLIDOS || '';
            json.generofamiliar = dataFamiliares.data[0].FAM_ASP_GENERO || '';
            json.nacimientofamiliar = dataFamiliares.data[0].FAM_ASP_EDAD || '';
            json.telefonosfamiliar = dataFamiliares.data[0].FAM_ASP_TELF_DOMICILIO || '';
            json.ocupacionfamiliar = dataFamiliares.data[0].FAM_ASP_OCUPACION || '';
            json.trabajofamiliar = dataFamiliares.data[0].FAM_ASP_LUGAR_TRABAJO || '';
            json.telefonotrabajofamiliar = dataFamiliares.data[0].FAM_ASP_TELF_TRABAJO || '';
        }
        json.idiomas = dataIdiomas.data.map((item: any, index: any) => (
            {
                idioma: idiomas(item.IDI_ID),
                comprende: comprende(item.IDI_ASP_COMPRENDE),
                habla: comprende(item.IDI_ASP_HABLA),
                lee: comprende(item.IDI_ASP_LEE),
                escribe: comprende(item.IDI_ASP_ESCRIBE),
                traduce: comprende(item.IDI_ASP_TRADUCE)
            }
        ));
        if (dataCapacitaciones.data != null) {
            json.cursos = dataCapacitaciones.data.map((item: any, index: any) => (
                {
                    curso: item.CAP_ASP_CURSO,
                    institucion: item.CAP_ASP_INSTITUCION,
                    horas: item.CAP_ASP_HORAS,
                    pais: item.PAI_ID,
                    ciudad: item.CAP_ASP_CIUDAD,
                    anio: item.CAP_ASP_ANIO
                }
            ));
        }
        if (dataTrayectoria.data != null) {
            json.experienciatrabaja = dataTrayectoria.data.TRA_ASP_TRABAJO_ACTUAL || '';
            json.experienciaingreso = dataTrayectoria.data.TRA_ASP_FECHA_INGRESO?.substring(0, 10) || '';
            json.experienciaempresa = dataTrayectoria.data.TRA_ASP_NOMBRE_EMPRESA || '';
            json.experienciacargo = dataTrayectoria.data.TRA_ASP_CARGO || '';
            json.experienciajefe = dataTrayectoria.data.TRA_ASP_NOMBRE_JEFE || '';
            json.experienciacargojefe = dataTrayectoria.data.TRA_ASP_CARGO_JEFE || '';
            json.experienciacontacto = dataTrayectoria.data.TRA_ASP_TELEFONO_CONTACTO || '';
            json.experienciaciudad = dataTrayectoria.data.TRA_ASP_CIUDAD_TRABAJO || '';
        }

        json.trayectoria = dataDetalle.data.map((item: any, index: any) => (
            {
                cargo: item.DET_EXP_CARGO,
                empresa: item.DET_EXP_EMPRESA,
                ingreso: item.DET_EXP_FECHA_INGRESO?.substring(0, 10),
                salida: item.DET_EXP_FECHA_SALIDA?.substring(0, 10),
            }
        ));
        if (dataCondicion.data != null) {
            json.condicionremuneracion = dataCondicion.data.CON_ASP_REMUNERACION || '';
            json.condicioneventual = dataCondicion.data.CON_ASP_TRABAJO_EVENTUAL || '';
            json.condicionviajar = dataCondicion.data.CON_ASP_DISPONIBILIDAD_VIAJAR || '';
            json.condicioncambio = dataCondicion.data.CON_ASP_DISP_TRAB_OTRA_CIUDAD || '';
            json.condicionturnos = dataCondicion.data.CON_ASP_TURNOS_ROTATIVOS || '';
            json.condiciondisponibilidad = dataCondicion.data.CON_ASP_TRABAJO_INMEDIATO || '';
            json.condicionfechaingresar = dataCondicion.data.CON_ASP_FECHA_INTEGRACION?.substring(0, 10) || '';
            json.condiciontrabajoeeq = dataCondicion.data.CON_ASP_TRABAJO_EEQ_ANTES || '';
        }

        if (dataEvaluacion.data != null) {
            json.evaluacion = dataEvaluacion.data.map((item: any, index: any) => (
                {
                    periodoevaluacion: item.EVA_ASP_PERIODO,
                    institucionevaluacion: item.EVA_ASP_INSTITUCION,
                    evaluacionobtenida: item.EVA_ASP_EVALUACION,
                }
            ));
        }

        if (dataEventos.data != null) {
            json.eventos = dataEventos.data.map((item: any, index: any) => (
                {
                    institucionexposicion: item.EVE_ASP_INSTITUCION,
                    temaexpuesto: item.EVE_ASP_TEMA,
                    fechaexposicion: item.EVE_ASP_FECHA?.substring(0, 10),
                    duracionexposicion: item.EVE_ASP_DURACION,
                    documentoexposicion: item.EVE_ASP_DOCUMENTO,
                }
            ));
        }

        if (dataPremios.data != null) {
            json.premios = dataPremios.data.map((item: any, index: any) => (
                {
                    institucionpremio: item.PRE_ASP_INSTITUCION,
                    temapremio: item.PRE_ASP_TEMA,
                    fechapremio: item.PRE_ASP_FECHA?.substring(0, 10),
                    documentopremio: item.PRE_ASP_DOCUMENTO,
                }
            ));
        }

        if (dataServicios.data != null) {
            json.servicios = dataServicios.data.map((item: any, index: any) => (
                {
                    institucionservicio: item.SER_ASP_INSTITUCION,
                    motivoservicio: item.SER_ASP_MOTIVO,
                    fechaservicio: item.SER_ASP_FECHA?.substring(0, 10),
                }
            ));
        }

        if (dataReferencias.data != null) {
            json.referencias = dataReferencias.data.map((item: any, index: any) => (
                {
                    nombresreferencia: item.REF_ASP_NOMBRES,
                    lugarreferencia: item.REF_ASP_LUGAR_TRABAJO,
                    cargoreferencia: item.REF_ASP_CARGO,
                    telefonoreferencia: item.REF_ASP_TELEFONO,
                    telefonoalterreferencia: item.REF_ASP_TELEFONO_ALTERNO,
                }
            ));
        }

        const responsePdf = await fetch(`${process.env.REACT_APP_API_URL}pdf`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(json)
        });
        const responseJson = await responsePdf.json();
        setBase64(responseJson.data);
    }
    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            navigate('/');
        }
    }, [navigate]);

    const base64ToPdf = (base64String: string) => {
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);

        const newTab = window.open();
        if (newTab) {
            newTab.document.open();
            newTab.document.write(
                `<iframe src="${url}" width="100%" height="100%"></iframe>`
            );
            newTab.document.close();
        } else {
            console.error('No se pudo abrir una nueva pestaña del navegador.');
        }
    };

    const handleConvertClick = () => {
        const base64String = base64;
        base64ToPdf(base64String);
    };
    return (
        <div className='d-flex justify-content-center align-items-center flex-column gap-5'>
            <h1>Hoja de Vida</h1>
            <button className='btn btn--radius-2 btn--blue' onClick={handleConvertClick}>Imprimir</button>
        </div>
    );
}

export default Imprimir;
